import api from './api';
import type { Lead } from '../types';

export const leadService = {
  getLeads: async (params?: { status?: string; source?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.status) searchParams.append('status', params.status);
    if (params?.source) searchParams.append('source', params.source);
    const response = await api.get(`/api/leads?${searchParams.toString()}`);
    return response.data.data as { leads: Lead[]; total: number };
  },

  createLead: async (data: { name: string; email?: string; phone?: string; source: string; notes?: string; websiteId: string }) => {
    const response = await api.post('/api/leads', data);
    return response.data.data as Lead;
  },

  updateLead: async (id: string, data: Partial<Lead>) => {
    const response = await api.patch(`/api/leads/${id}`, data);
    return response.data.data as Lead;
  },

  deleteLead: async (id: string) => {
    await api.delete(`/api/leads/${id}`);
  },

  markViewed: async (id: string) => {
    const response = await api.post(`/api/leads/${id}/view`);
    return response.data.data as Lead;
  },

  getUnreadCount: async () => {
    const response = await api.get('/api/leads/unread-count');
    return response.data.data.count as number;
  },

  bulkUpdateStatus: async (leadIds: string[], status: string) => {
    await api.post('/api/leads/bulk/status', { leadIds, status });
  },

  bulkDelete: async (leadIds: string[]) => {
    await api.post('/api/leads/bulk/delete', { leadIds });
  },

  bulkExport: async (leadIds: string[]) => {
    const response = await api.post('/api/leads/bulk/export', { leadIds }, { responseType: 'blob' });
    return response.data as Blob;
  },

  exportAll: async () => {
    const response = await api.get('/api/export/leads', { responseType: 'blob' });
    return response.data as Blob;
  },
};
